export default {
  computed: {
    programId() {
      return this.$route.params.programId;
    },
  },
};
